import { FaroCoreApiTypes, FaroCoreApiUtils } from "@stellar/core-api-client";
import { UiUtils } from "@stellar/utils";
import { formatStorageMaxValue } from "@utils/limit-data-display";

/**
 * Returns the display name of the project manager based on the email.
 * If the member is a user group, it returns the name of the user group.
 * Otherwise, it returns the email address.
 *
 * @param groupMembers - Array of group members
 * @param email - Email address of the project manager
 * @returns Display name of the project manager
 */
export function getProjectManagerDisplay(
  groupMembers: FaroCoreApiTypes.AdmGroupMember[],
  email: string
): string {
  const member = groupMembers.find(({ user }) => user.email === email);
  if (member && FaroCoreApiUtils.Member.isTeam(member.user)) {
    return member.user.name ?? "";
  }
  return email;
}

/**
 * Format the project storage size to be displayed in the UI
 * If the storage size is not available or is zero, it returns a dash (DASH)
 */
export function formatProjectStorageSize(
  sizeInBytes: number | undefined
): string {
  if (!sizeInBytes) {
    return UiUtils.DASH;
  }
  return `${parseFloat(formatStorageMaxValue(sizeInBytes, "GB")).toFixed(
    2
  )} GB`;
}
